module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.f27c9a9bd57d9604.js");
}
